import type { Caching } from "@/lib/caching"
import { isRecord } from "@/lib/validation/isRecord"

export const isCachingMetadata = (
  subject: unknown
): subject is Caching.Metadata => {
  if (!isRecord(subject)) {
    return false
  }

  if (!subject.cachedAt) {
    return false
  }

  if (subject.expiresAt && typeof subject.expiresAt !== `number`) {
    return false
  }

  if (subject.expiry && typeof subject.expiry !== `number`) {
    return false
  }

  return true
}
